// src/components/documents/ui/DocumentChatUI.tsx
import { cn } from "@/lib/utils"
import type { ReactNode, HTMLAttributes } from "react"

export const documentChatTheme = {
  mainContainer: "flex flex-col h-full bg-purple-950/80 backdrop-blur-2xl border border-purple-300/40 rounded-3xl overflow-hidden shadow-2xl shadow-purple-500/20",

  searchHeader: "p-5 border-b border-purple-300/30 bg-purple-950/70 backdrop-blur-2xl",

  searchInput: "pl-12 bg-purple-950/70 border-purple-300/40 text-white placeholder:text-purple-400/70 rounded-3xl text-xl h-12 focus:border-purple-400",

  chatArea: "flex-1 px-6 py-8 overflow-y-auto no-scrollbar",

  emptyState: "flex flex-col items-center justify-center h-full text-purple-400 gap-6 py-12",

  messageBubble: (isOwn: boolean, isFirstInGroup: boolean) => cn(
    "group relative max-w-[72%] px-6 py-4 rounded-3xl text-xl leading-relaxed shadow-xl transition-all duration-200 hover:shadow-2xl cursor-pointer",
    isOwn
      ? "bg-gradient-to-br from-purple-600/95 to-pink-600/92 text-white rounded-br-none ml-auto"
      : "bg-purple-950/70 backdrop-blur-xl border border-purple-300/40 text-purple-100 rounded-bl-none",
    isFirstInGroup
      ? isOwn ? "rounded-tr-3xl" : "rounded-tl-3xl"
      : isOwn ? "rounded-tr-2xl rounded-br-2xl" : "rounded-tl-2xl rounded-bl-2xl"
  ),

  systemMessage: "flex justify-center",
  systemBubble: "max-w-md bg-purple-950/70 border border-purple-300/40 rounded-3xl px-8 py-5 text-center text-lg text-purple-200 shadow-inner",

  dateSeparator: "bg-purple-950/80 px-6 py-3 rounded-full text-lg text-purple-300 border border-purple-300/40 shadow-md",

  fileAttachment: "mt-4 bg-purple-950/60 backdrop-blur-xl border border-purple-300/30 rounded-3xl p-5 flex items-center justify-between gap-4",

  editingTextarea: "w-full bg-purple-950/60 border border-purple-300/40 rounded-2xl px-5 py-4 text-xl text-white resize-none focus:outline-none focus:border-purple-400 font-normal",

  replyBanner: "bg-purple-900/40 border-t border-purple-300/40 px-6 py-3 flex items-center gap-3",

  inputBar: "p-6 border-t border-purple-300/30 bg-purple-950/70 backdrop-blur-2xl",

  typingIndicator: "text-purple-400/70 italic text-xl mt-8 text-center animate-pulse",

  avatarOther: "bg-gradient-to-br from-blue-600 to-cyan-600 text-white text-base font-bold h-9 w-9",
  avatarOwn: "bg-gradient-to-br from-purple-600 to-pink-600 text-white text-base font-bold h-9 w-9",
} as const

export function MessageBubble({
  isOwn,
  isFirstInGroup,
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & { isOwn: boolean; isFirstInGroup: boolean }) {
  return (
    <div
      className={cn(documentChatTheme.messageBubble(isOwn, isFirstInGroup), className)}
      {...props}
    >
      {children}
    </div>
  )
}